import React from "react";
import { FaStar, FaUserCircle } from "react-icons/fa";
import { ref, set } from "firebase/database";
import { db } from "../../Pages/OurProduct/firebase";
import { myCustomTheme } from "../../Theme";
import "./style/ReviewSection.css";

const ReviewSection = ({ selectedProduct, newReview, setNewReview, setSelectedProduct, showToast }) => {
    const handleReviewSubmit = (e) => {
        e.preventDefault();
        if (!newReview.name.trim() || !newReview.comment.trim()) return;

        const craftedReview = {
            id: Date.now(),
            name: newReview.name,
            rating: parseInt(newReview.rating),
            comment: newReview.comment,
            date: new Date().toLocaleDateString("en-US", {
                year: "numeric", month: "long", day: "numeric"
            })
        };

        const currentReviews = selectedProduct.reviews || [];
        const structuralReviews = [...currentReviews, craftedReview];
        const compositeScore = structuralReviews.reduce((sum, rev) => sum + rev.rating, 0);
        const computedAverage = parseFloat((compositeScore / structuralReviews.length).toFixed(1));

        const synchronizedProduct = {
            ...selectedProduct,
            reviews: structuralReviews,
            rating: computedAverage
        };

        set(ref(db, `products/${selectedProduct.id}`), synchronizedProduct).then(() => {
            setSelectedProduct(synchronizedProduct);
            setNewReview({ name: "", rating: 5, comment: "" });
            showToast("Review submitted successfully!");
        });
    };

    return (
        <div className="reviews-section-wrapper">
            <hr className="section-divider" style={{ backgroundColor: myCustomTheme.colors.high_light }} />
            <div className="reviews-layout-grid">
                <div className="reviews-list-container">
                    <h2 style={{ color: myCustomTheme.colors.heading }}>
                        Customer Reviews (
                        <FaStar
                            className="star-filled"
                            style={{ fontSize: "18px", margin: "0 4px 4px 0", color: "#f59e0b" }}
                        />
                        {selectedProduct.rating})
                    </h2>

                    {selectedProduct.reviews && selectedProduct.reviews.length > 0 ? (
                        <div className="reviews-scroll-area">
                            {selectedProduct.reviews.map((rev) => (
                                <div
                                    key={rev.id}
                                    className="review-comment-card"
                                    style={{
                                        backgroundColor: myCustomTheme.colors.bg_secondary,
                                        borderRadius: "16px"
                                    }}
                                >
                                    <div className="review-comment-header">
                                        <div className="reviewer-meta">
                                            <FaUserCircle
                                                className="reviewer-avatar-icon"
                                                style={{ color: myCustomTheme.colors.icon_color }}
                                            />
                                            <div>
                                                <span className="reviewer-name" style={{ color: myCustomTheme.colors.heading }}>
                                                    {rev.name}
                                                </span>
                                                <span className="reviewer-date" style={{ color: myCustomTheme.colors.menu_text }}>
                                                    {rev.date}
                                                </span>
                                            </div>
                                        </div>
                                        <div className="reviewer-score-stars">
                                            {[...Array(5)].map((st, i) => (
                                                <FaStar
                                                    key={i}
                                                    className={i < rev.rating ? "star-filled" : "star-muted"}
                                                    style={{
                                                        color: i < rev.rating ? "#f59e0b" : myCustomTheme.colors.bg_secondary
                                                    }}
                                                />
                                            ))}
                                        </div>
                                    </div>
                                    <p className="review-body-text" style={{ color: myCustomTheme.colors.p_text }}>
                                        "{rev.comment}"
                                    </p>
                                </div>
                            ))}
                        </div>
                    ) : (
                        <p
                            className="no-reviews-prompt"
                            style={{
                                backgroundColor: myCustomTheme.colors.bg_secondary,
                                color: myCustomTheme.colors.menu_text,
                                borderRadius: "12px"
                            }}
                        >
                            No reviews yet. Be the first to review!
                        </p>
                    )}
                </div>

                <div
                    className="add-review-form-box"
                    style={{
                        backgroundColor: myCustomTheme.colors.bg_secondary,
                        borderRadius: "20px"
                    }}
                >
                    <h3 style={{ color: myCustomTheme.colors.heading }}>Add Your Review</h3>
                    <form onSubmit={handleReviewSubmit} className="review-submission-form">
                        <div className="review-form-group">
                            <label className="review-input-label">Your Name</label>
                            <input
                                type="text"
                                placeholder="Enter your name"
                                value={newReview.name}
                                onChange={(e) => setNewReview({ ...newReview, name: e.target.value })}
                                required
                                style={{ borderRadius: "8px" }}
                            />
                        </div>
                        <div className="review-form-group">
                            <label className="review-input-label">Rating Score</label>
                            <select
                                value={newReview.rating}
                                onChange={(e) => setNewReview({ ...newReview, rating: parseInt(e.target.value) })}
                                style={{ borderRadius: "8px" }}
                            >
                                <option value="5">Excellent</option>
                                <option value="4">Good</option>
                                <option value="3">Average</option>
                            </select>
                        </div>
                        <div className="review-form-group">
                            <label className="review-input-label">Comments</label>
                            <textarea
                                placeholder="Share details of your experience..."
                                value={newReview.comment}
                                onChange={(e) => setNewReview({ ...newReview, comment: e.target.value })}
                                required
                                style={{ borderRadius: "8px" }}
                            />
                        </div>
                        <button
                            type="submit"
                            className="submit-review-btn"
                            style={{
                                backgroundColor: myCustomTheme.colors.button_bg,
                                color: myCustomTheme.colors.button_text,
                                borderRadius: "8px"
                            }}
                        >
                            Submit Review
                        </button>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default ReviewSection;